import styles from "./FormOffers.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const FormOffers = ({ offers }: any) => (
  <div className={styles.bookFormOfferSection}>
    {offers.map((offer: any, index: number) => (
      <div className={styles.offerDiv} key={offer.name + index}>
        <div className={styles.numberBadge}>{index + 1}</div>
        <div className={styles.offerContent}>
          <div className={styles.offerTitle}>{offer.name}</div>
          <div
            className={styles.offerSubTitle}
            dangerouslySetInnerHTML={{
              __html: offer.description,
            }}
          />
        </div>
      </div>
    ))}
  </div>
);

export default wrapperHOC(FormOffers, {
  componentName: "FormOffers-FormLayout-Global",
  showForChina: true,
});
